export default "__VITE_ASSET__DidAOmhY__"